export enum SyntaxTheme {
  Light = "spacelift-light",
  Dark = "spacelift-dark",
  SolarizedLight = "solarized-light",
  SolarizedDark = "solarized-dark",
  Dracula = "dracula",
  Nord = "nord",
}
